/* eslint-disable max-len */

import React from 'react';
import { Defs, G, Path, Svg } from '@react-pdf/renderer';

export const CoffeeIcon: React.FC = () => {
  return (
    <Svg width={42} height={42}>
      <Defs>
        <Path d="M0 0h29.798v20.857H0z" />
      </Defs>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M37.246 0c0 2.89 1.756 4.023 3.134 4.468l.261.077.126.033.241.055.114.023.212.036.274.036.309.024.083.002v32.492c-2.89 0-4.023 1.756-4.468 3.134l-.077.261a6.125 6.125 0 0 0-.033.126l-.055.241a6.301 6.301 0 0 0-.023.114l-.036.212-.036.274-.024.309-.002.083H4.754c0-2.89-1.756-4.023-3.134-4.468l-.261-.077a6.125 6.125 0 0 0-.126-.033l-.241-.055a6.3 6.3 0 0 0-.114-.023l-.212-.036-.274-.036-.309-.024L0 37.246V4.754c2.89 0 4.023-1.756 4.468-3.134l.077-.261.033-.126.055-.241a6.3 6.3 0 0 0 .023-.114l.036-.212.036-.274.024-.309L4.754 0h32.492Zm-.782.827H5.503l-.04.237a6.454 6.454 0 0 1-.648 1.846c-.756 1.398-2 2.332-3.756 2.595l-.232.03v30.961l.237.041a6.454 6.454 0 0 1 1.846.648c1.398.756 2.332 2 2.595 3.756l.03.232h30.96l.042-.237a6.454 6.454 0 0 1 .648-1.846c.756-1.398 2-2.332 3.756-2.595l.232-.031V5.504l-.237-.041a6.454 6.454 0 0 1-1.846-.648c-1.398-.756-2.332-2-2.595-3.756l-.031-.232Z"
          fill="#CCCBCB"
          fillRule="nonzero"
        />
        <G transform="translate(6.000000, 11.000000)">
          <Path d="M0 0h29.798v20.857H0z" />
          <Path
            d="M8.941 16.388h8.94a4.47 4.47 0 0 0 4.468-4.47h1.49A5.965 5.965 0 0 0 29.8 5.96 5.965 5.965 0 0 0 23.838 0H5.59C4.97 0 4.472.499 4.472 1.118v10.8a4.47 4.47 0 0 0 4.47 4.47ZM23.84 2.98a2.982 2.982 0 0 1 2.98 2.98 2.982 2.982 0 0 1-2.98 2.979h-1.49v-5.96h1.49Zm2.22 17.877c2.221 0 2.836-2.98 1.672-2.98H.575c-1.164 0-.54 2.98 1.676 2.98H26.06Z"
            fill="#92613E"
          />
        </G>
      </G>
    </Svg>
  );
};
